module.exports = require("ts-loader");